module.exports = __webpack_public_path__ + "media/images/icons/filled/layout-20f000411bc26a08c4daa5aa3341ff04.svg";